function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#3c5870;stroke:#f6f6f6}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "import",
  transform: "translate(.5 .5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_6807",
  d: "M26.26 16.464H20.9v3.179h5.36c1.594 0 2.83.813 2.83 1.514v14.1c0 .7-1.236 1.514-2.83 1.514H6.009c-1.593 0-2.829-.814-2.829-1.514v-14.1c0-.7 1.236-1.514 2.829-1.514h5.357v-3.178H6.009C2.639 16.465 0 18.527 0 21.158v14.1c0 2.632 2.639 4.693 6.009 4.693h20.252c3.368 0 6.009-2.062 6.009-4.693v-14.1c-.001-2.632-2.64-4.694-6.01-4.694z",
  className: "cls-1",
  "data-name": "Path 6807",
  transform: "translate(0 -7.803)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_6808",
  d: "M29.676 8.04a1.584 1.584 0 0 1-1.124-.466l-1.99-1.99v16.172a1.59 1.59 0 0 1-3.179 0V5.477l-2.1 2.1a1.589 1.589 0 0 1-2.248-2.247L23.784.582a1.583 1.583 0 0 1 1.123-.465h.024a1.582 1.582 0 0 1 1.123.465L30.8 5.328a1.589 1.589 0 0 1-1.124 2.712z",
  className: "cls-1",
  "data-name": "Path 6808",
  transform: "translate(-8.732 -.117)"
}));

function SvgImport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33.269,
    height: 33.145,
    viewBox: "0 0 33.269 33.145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.5bf74933.svg";
export { ForwardRef as ReactComponent };